import { call, fork, put, takeEvery } from 'redux-saga/effects';
import { MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT } from '../../../../constants/service/app/recommendStoreConstants';
import { RECOMMEND_STORE_LIST_URL_PATH } from '../../../../constants/service/common/urlConstants';
import recommendStoreToastMsg from '../../../../constants/service/toastMsg/recommendStoreToastMsg';
import RecommendStoreApi from '../../../../lib/api/recommend/store/RecommendStoreApi';
import {
  _setResponseListForm,
  asyncSimpleModal,
  excelDownLoad,
  reDirectPage,
  setMultipartForm,
  setRequestForm,
} from '../../../../lib/common';
import toastMsg from '../../../../lib/toastMsg';
import { recommendStoreActions } from './index';

function* fetchList() {
  /**
   *   추천 브랜드 리스트 가져오기
   */
  yield takeEvery(recommendStoreActions.GET_RECOMMEND_STORE_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendStoreApi.getRecommendStoreList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.GET_RECOMMEND_STORE_LIST_REQUEST_SUCCESS);

        const data = {
          recommendStoreList: _setResponseListForm(result.data.recommendStoreList, result.data.totalCnt, payload),
        };

        yield put({ type: recommendStoreActions.GET_RECOMMEND_STORE_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendStoreToastMsg.GET_RECOMMEND_STORE_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 브랜드 상세 요청하기
   */
  yield takeEvery(recommendStoreActions.GET_RECOMMEND_STORE_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendStoreApi.getRecommendStoreDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.GET_RECOMMEND_STORE_DETAIL_REQUEST_SUCCESS);

        const data = {
          recommendStoreDetail: {
            recommendStoreInfo: result.data.recommendStoreInfo,
            recommendStoreItemList: result.data.recommendStoreItemList,
          },
        };

        yield put({ type: recommendStoreActions.GET_RECOMMEND_STORE_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendStoreToastMsg.GET_RECOMMEND_STORE_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 브랜드 복사하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendStoreActions.PREPARE_COPY_RECOMMEND_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendStoreApi.prepareCopyRecommendStore, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.PREPARE_COPY_RECOMMEND_STORE_REQUEST_SUCCESS);

        const data = {
          recommendStoreSave: {
            recommendStoreInfo: result.data.recommendStoreInfo,
            selectedRecommendStoreItemList: result.data.selectedRecommendStoreItemList,
            recommendStoreItemList: _setResponseListForm(
              result.data.recommendStoreItemList.list,
              result.data.recommendStoreItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendStoreActions.PREPARE_COPY_RECOMMEND_STORE_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendStoreToastMsg.PREPARE_COPY_RECOMMEND_STORE_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 브랜드 등록하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(recommendStoreActions.PREPARE_CREATE_RECOMMEND_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendStoreApi.prepareCreateRecommendStore, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.PREPARE_CREATE_RECOMMEND_STORE_REQUEST_SUCCESS);

        const data = {
          recommendStoreSave: {
            recommendStoreItemList: _setResponseListForm(
              result.data.recommendStoreItemList.list,
              result.data.recommendStoreItemList.totalCnt,
              payload,
            ),
          },
        };
        yield put({ type: recommendStoreActions.PREPARE_CREATE_RECOMMEND_STORE_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendStoreToastMsg.PREPARE_CREATE_RECOMMEND_STORE_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 브랜드에 연결할 아이템 리스트 요청하기
   */
  yield takeEvery(recommendStoreActions.GET_RECOMMEND_STORE_ITEM_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendStoreApi.getRecommendStoreItemList, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.GET_RECOMMEND_STORE_ITEM_REQUEST_SUCCESS);

        const data = {
          recommendStoreItemList: _setResponseListForm(
            result.data.recommendStoreItemList.list,
            result.data.recommendStoreItemList.totalCnt,
            payload,
          ),
        };

        yield put({ type: recommendStoreActions.GET_RECOMMEND_STORE_ITEM_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendStoreToastMsg.GET_RECOMMEND_STORE_ITEM_REQUEST_ERROR, error);
    }
  });

  /**
   *   추천 브랜드 등록/복사하기
   */
  yield takeEvery(recommendStoreActions.CREATE_RECOMMEND_STORE_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(RecommendStoreApi.createRecommendStore, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.CREATE_RECOMMEND_STORE_REQUEST_SUCCESS);

        reDirectPage({ path: RECOMMEND_STORE_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(recommendStoreToastMsg.CREATE_RECOMMEND_STORE_REQUEST_ERROR, error);
    }
  });

  /**
   *   전체 브랜드 리스트 EXCEL 다운로드
   */
  yield takeEvery(recommendStoreActions.GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        RecommendStoreApi.getRecommendStoreItemListExcelDownload,
        setRequestForm(payload, true),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

        excelDownLoad('브랜드 아이템 리스트', result.data.recommendStoreItemExcelSheet);
      }
    } catch (error) {
      toastMsg.error(
        error.message || recommendStoreToastMsg.GET_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
        error,
      );
    }
  });

  /**
   *   선택된 브랜드 리스트 EXCEL 다운로드
   */
  yield takeEvery(
    recommendStoreActions.GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST,
    function* ({ payload }) {
      try {
        const result = yield call(
          RecommendStoreApi.getSelectedRecommendStoreItemListExcelDownload,
          setRequestForm(payload, true),
        );
        if (result.msg) {
          toastMsg.error(result.msg);
        } else {
          toastMsg.success(
            recommendStoreToastMsg.GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS,
          );

          excelDownLoad('브랜드 아이템 리스트', result.data.recommendStoreItemExcelSheet);
        }
      } catch (error) {
        toastMsg.error(
          error.message || recommendStoreToastMsg.GET_SELECTED_RECOMMEND_STORE_ITEM_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR,
          error,
        );
      }
    },
  );

  /**
   *  브랜드 리스트 EXCEL 업로드
   */
  yield takeEvery(recommendStoreActions.SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(
        RecommendStoreApi.setRecommendStoreItemListExcelUpload,
        setMultipartForm(payload, true),
      );
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(recommendStoreToastMsg.SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST_SUCCESS);

        /**
         *  추가하려고 하는 추천 브랜드 아이템 개수가 초가되었을 경우
         *  업로드를 하지 못하도록 함
         */
        if (result.data.totalCnt > MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT) {
          yield asyncSimpleModal({
            type: 'error',
            title: '아이템 개수 초과',
            message: `추천 브랜드 아이템 개수는 최대 ${MAXIMUM_NUMBER_OF_RECOMMEND_STORE_ITEM_COUNT} 입니다.`,
          });
          return;
        }

        const data = {
          ...result.data,
          form: payload.form,
        };

        yield put({ type: recommendStoreActions.SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(recommendStoreToastMsg.SET_RECOMMEND_STORE_ITEM_LIST_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
